import { images } from 'assets/images';

export const MOCK_DATA ={
    "XRS Bullet Yacht" :images.bullet,
    "X Falcon":images.plane,
    "XRS Off-road Truck":images.car,
    "XS Roadster":images.roadster,
    "XS Motorcycle":images.moto
}
